import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { PainSection } from '../components/sales/PainSection';
import { ReframeSection } from '../components/sales/ReframeSection';
import { ProductSection } from '../components/sales/ProductSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { FAQSection } from '../components/sales/FAQSection';
import { CTASection } from '../components/sales/CTASection';
// Declare fbq on window for TypeScript
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
export function SalesPage() {
  useEffect(() => {
    // Meta Pixel init — inject script safely
    if (!window.fbq) {
      const n: Window['fbq'] = function (...args: unknown[]) {
        // @ts-ignore
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      // @ts-ignore
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '1609417253435117');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-brand-cream selection:bg-brand-terracotta selection:text-white" data-id="element-162">
      <HeroSection data-id="element-163" />
      <PainSection data-id="element-164" />
      <ReframeSection data-id="element-165" />
      <ProductSection data-id="element-166" />
      <TestimonialsSection data-id="element-167" />
      <GuaranteeSection data-id="element-168" />
      <FAQSection data-id="element-169" />
      <CTASection data-id="element-170" />

      <footer className="bg-brand-dark text-brand-cream/40 py-8 text-center text-sm" data-id="element-171">
        <div className="max-w-7xl mx-auto px-4" data-id="element-172">
          <p data-id="element-173">
            &copy; {new Date().getFullYear()} SOS Premenopausia. Todos los
            derechos reservados.
          </p>
          <div className="mt-2 space-x-4" data-id="element-174">
            <a href="#" className="hover:text-brand-cream transition-colors" data-id="element-175">
              Aviso Legal
            </a>
            <a href="#" className="hover:text-brand-cream transition-colors" data-id="element-176">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-brand-cream transition-colors" data-id="element-177">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </main>;
}